
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bLk1w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ResizeButtonTooltip", () => $d7e9605a54ddd26e$export$680dc7b2ca125eea);
$parcel$export(module.exports, "TooltipNode", () => $d7e9605a54ddd26e$export$650cc9b24ce3a5c9);
$parcel$export(module.exports, "default", () => $d7e9605a54ddd26e$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");

var $dTocu = parcelRequire("dTocu");

var $hrO1d = parcelRequire("hrO1d");
const $d7e9605a54ddd26e$export$680dc7b2ca125eea = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, children: children })=>{
    const intl = (0, $dTocu.useIntlV2)();
    const text = isLeftSidebarCollapsed ? intl.formatMessage((0, $hrO1d.messages).expand) : intl.formatMessage((0, $hrO1d.messages).collapse);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7e9605a54ddd26e$export$650cc9b24ce3a5c9, {
            text: text,
            char: "["
        }),
        hideTooltipOnClick: true,
        position: "right",
        testId: "page-container-v2.common.ui.sidebar.resize-button-tooltip.tooltip"
    }, children);
};
var $d7e9605a54ddd26e$export$2e2bcd8739ae039 = $d7e9605a54ddd26e$export$680dc7b2ca125eea;
const $d7e9605a54ddd26e$export$650cc9b24ce3a5c9 = ({ text: text, char: char })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7e9605a54ddd26e$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7e9605a54ddd26e$var$ShortcutWrapper, null, char));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d7e9605a54ddd26e$var$TooltipWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1q9y _1e0c1txw _n3tdv77o _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $d7e9605a54ddd26e$var$ShortcutWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _bfhk1bsc _18u01b66 _ca0qt94y _u5f3u2gc _n3tdt94y _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hrO1d", function(module, exports) {

$parcel$export(module.exports, "messages", () => $348ec2c46a60fe3f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $348ec2c46a60fe3f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    expand: {
        "id": "page-container-v2.common.sidebar.resize-button-tooltip.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "page-container-v2.common.sidebar.resize-button-tooltip.collapse",
        "defaultMessage": "Collapse"
    }
});

});



//# sourceMappingURL=async-sidebar-resize-button.dffba6fa.js.map
